import { useDayUi } from '../features/day/dayUiStore';
import { pickerFieldsDirty } from '../features/day/picker/pickerModel';
import type { GestureTracker } from './workerUpdate';

/**
 * Defers the worker-update reload while the picker holds unsaved modifications (2026-10b
 * §5.4): the same mechanism as the drag deferral. The reload runs as soon as the picker
 * becomes clean or closes.
 */
export function trackPickerDirty(): GestureTracker {
  let pending: (() => void) | null = null;
  useDayUi.subscribe((state) => {
    if (pending === null || pickerFieldsDirty(state.pickerFields)) return;
    const run = pending;
    pending = null;
    run();
  });
  return {
    active: () => pickerFieldsDirty(useDayUi.getState().pickerFields),
    onIdle(callback) {
      pending = callback;
    },
  };
}
